import * as React from 'react';
import { Box, Button, Card, Checkbox, CircularProgress, Grid, Input, Link, Modal, ModalDialog, Option, Select, Sheet, Stack, Textarea, Typography } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { addNovaListaParaListas, addNovoTodoParaTodos, carregaLista, changeAttrModification, endDrag, loadTodosDB, removeTodo, removerLista, salvarEditTodo, setEditTodo, setEditTodoFormAttr, setNovaListFormAttr, setNovoTodoFormAttr, setSelectedListaById, setSelectedListaPadrao, startDrag, startSalvarDB, toggleDefault, toggleTodoConlusao, updateDragOver } from "./TodosSlice";
import { AddCircle, Calculate, Check, DragHandleRounded } from '@mui/icons-material';
import { novoDB, triggerLoadNovoDB } from '../dbs/dbsSlice';
import { formatDateComHoras, formatDateJavaComHoras, formatDateSemHoras, isNotNull, isNull } from '../helper/functions';
import { novaConfirmacao, startConfirmacao } from '../helper/confirmation-modal/confirmationSlice';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { v4 } from 'uuid';

//Icons
import StarIcon from '@mui/icons-material/Star';

import { Link as LinkRouter } from "react-router-dom"
function ModalNovaLista() {

    var isOpen = useSelector((state) => state.todos.novaListaForm.isOpen)
    var dfault = useSelector((state) => state.todos.novaListaForm.default)
    var nome = useSelector((state) => state.todos.novaListaForm.nome)
    var dispatch = useDispatch()
    var close = () => {
        dispatch(setNovaListFormAttr({
            campo: "isOpen",
            value: false
        }))
    }
    var salvar = () => {

        if (nome.trim().length > 0) {
            dispatch(addNovaListaParaListas())
            close()
        }

    }
    var updateValue = (campo, valor) => {
        dispatch(setNovaListFormAttr({
            campo,
            value: valor
        }))
    }

    return <Modal open={isOpen} onClose={close}>
        <ModalDialog
            aria-labelledby="basic-modal-dialog-title"
            aria-describedby="basic-modal-dialog-description"
            sx={{ width: 500 }}
        >
            <Typography id="basic-modal-dialog-title" component="h2">
                Nova lista
            </Typography>
            <Stack spacing={2}>
                <Input placeholder="Nome..." type="text" autoFocus onChange={(e) => updateValue("nome", e.target.value)}></Input>
                <Checkbox onChange={() => updateValue("default", !dfault)} label="Lista padrao" checked={dfault}></Checkbox>
                <Textarea minRows={10} onChange={(e) => updateValue("descricao", e.target.value)}></Textarea>
                <Box sx={{
                    textAlign: "right"
                }}>
                    <Button onClick={salvar}>Salvar</Button>
                </Box>
            </Stack>
        </ModalDialog>
    </Modal>
}


function ListasManager() {

    var dispatch = useDispatch()
    var listas = useSelector((state) => state.todos.listas)

    var selectedListaId = useSelector((state) => state.todos.selectedListaId)

    React.useEffect(() => {
        if (isNull(selectedListaId)) {
            var listaPadrao = listas.filter(l => l.default === true)[0]

            if (isNotNull(listaPadrao)) {
                dispatch(setSelectedListaById(listaPadrao.id))
            }
        }
    }, []);

    var lista = listas.filter(l => l.id === selectedListaId)[0]

    var selectLista = (e, value) => {
        dispatch(setSelectedListaById(value))
    }

    var openModal = () => {
        dispatch(setNovaListFormAttr({
            campo: "isOpen",
            value: true
        }))
    }

    return <Box style={{ width: "100%" }}>
        <Stack direction={"row"} spacing={1}>
            <Select sx={{ width: "100%" }} value={selectedListaId} onChange={selectLista}>
                {listas.map(e => <Option key={e.id} value={e.id}>{e.nome}</Option>)}
            </Select>
            <Button onClick={openModal}>+</Button>
        </Stack>
    </Box>
}

function DetalhesLista() {
    var listas = useSelector((state) => state.todos.listas)
    var selectedListaId = useSelector((state) => state.todos.selectedListaId)
    var lista = listas.filter(l => l.id === selectedListaId)[0]
    var dispatch = useDispatch()
    var todoForm = useSelector((state) => state.todos.novoTodoForm)
    var todoEditForm = useSelector((state) => state.todos.todoEditForm)

    var MostraDetalhesLista = (props) => {
        return <Grid xs={12}>
            <Stack>
                {props.lista.todos.length > 0 && "Sem nenhum todo"}
            </Stack>
        </Grid>
    }

    if (isNull(lista)) {
        return "Sem lista"
    }

    var cbDelete = () => {
        dispatch(removerLista(selectedListaId))
    }

    var updateTodoTitle = (e) => {
        dispatch(setNovoTodoFormAttr({
            campo: "titulo",
            value: e.target.value
        }))
    }

    var addTodo = () => {
        dispatch(addNovoTodoParaTodos())
    }

    var toggleConclusaoTodo = (t) => {
        dispatch(toggleTodoConlusao(t))
    }

    var removerTodo = (id) => {
        dispatch(removeTodo(id))
    }

    var updateTodoEditTitulo = (e) => {
        dispatch(setEditTodoFormAttr({
            campo: "titulo",
            value: e.target.value
        }))
    }

    var toggleEditTodo = (id, titulo) => {

        if (todoEditForm == null) {
            dispatch(setEditTodo({
                id,
                titulo
            }))
        } else if (todoEditForm.id == id) {
            dispatch(setEditTodo(null))
        } else {
            dispatch(setEditTodo({
                id,
                titulo
            }))
        }
    }

    var salvarEdicaoTodo = () => {
        dispatch(salvarEditTodo())
        dispatch(setEditTodo(null))
    }

    var listaToggleDefault = () => {
        dispatch(toggleDefault())
    }

    var dragStart = (index) => {
        // console.log("drag start", index)
        dispatch(startDrag(index))
    }

    var dragEnd = (index) => {
        // console.log("drag end", index)
        dispatch(endDrag(index))
    }

    var dragEnter = (index) => {
        // console.log("drag enter", index)
        dispatch(updateDragOver(index))
    }

    return <Box>
        <Stack>
            <Stack
                direction={"row"}
                spacing={1}
                sx={{
                    display: "Flex",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "middle"
                }}>
                <Box >
                    <Checkbox
                        label="Padrão"
                        checked={lista.default}
                        onClick={() => listaToggleDefault()} />
                </Box>
                <Button
                    sx={{ width: "150px" }}
                    color='danger'
                    onClick={() => {
                        dispatch(startConfirmacao(novaConfirmacao("Deseja remover a lista: " + lista.nome + "?", cbDelete)))
                    }}>Excluir lista</Button>
                <Input type="text" placeholder="TODO" autoFocus sx={{ width: "100%" }}
                    value={todoForm.titulo}
                    onChange={updateTodoTitle}
                ></Input>
                <Button color='danger' onClick={addTodo}>+</Button>
            </Stack>
            <Box sx={{
                padding: "10px 0 10px 0",
                display: lista.descricao.trim().length > 0 ? "block" : "none"
            }}>
                <Textarea contentEditable={false} value={lista.descricao} ></Textarea>
            </Box>

            <Box sx={{
                padding: "10px 0 0px 0"
            }}>
                <Stack direction={"row"} spacing={2}>
                    <LinkRouter to="/notetaker/editor/c217131c-cea9-472f-84be-678d9c2549dd" >
                        <Button color='danger' size='sm' sx={{ backgroundColor: "#004488" }}>Nota de Objetivos</Button>
                    </LinkRouter>
                    <Link href="https://trello.com/b/USfPSw51/gestao" target="_blank">
                        <Button color='danger' size='sm' sx={{ backgroundColor: "#000" }}>Trello - Anano</Button>
                    </Link>
                    <Typography>{selectedListaId}</Typography>
                </Stack>
            </Box>
            <Box sx={{ padding: "10px 0 0 0" }}>

                <Stack spacing={0.5} >
                    <Typography component="h2">A fazer</Typography>
                    {lista.todos.map((e, index) => {

                        var estiloRow = {
                            padding: "5px 10px",
                            display: "flex",
                            borderRadius: "3px",
                            justifyContent: "middle",
                        }

                        var estiloTag = {
                            backgroundColor: "#c20000",
                            padding: "0 10px",
                            borderRadius: "9px",
                            color: "#fff",
                            fontWeight: "bold"
                        }

                        var generateColor = (str) => {

                            const cores = [
                                '#3CB44B', // verde
                                '#4363D8', // azul
                                '#F58231', // laranja
                                '#911EB4', // roxo
                                '#42D4F4', // ciano
                                '#c20000', // vermelho
                                '#F032E6', // magenta
                                '#BFEF45', // verde-limão
                                '#FABE28', // amarelo
                                '#469990', // verde-petróleo
                                '#DCBEFF', // lilás
                                '#9A6324', // marrom
                                '#808000', // oliva
                                '#800000', // vinho
                                '#000075'  // azul-marinho
                            ];

                            let hash = 0;

                            for (let i = 0; i < str.length; i++) {
                                hash = ((hash << 5) - hash) + str.charCodeAt(i);
                                hash |= 0; // mantém inteiro de 32 bits
                            }

                            return cores[Math.abs(hash) % cores.length];

                        }


                        var estiloTitulo = {}

                        if (e.titulo.includes("-----")) {
                            estiloRow = {
                                ...estiloRow,
                                background: "#e56a6a",
                                color: "#fff"
                            }

                            estiloTitulo = {
                                ...estiloTitulo,
                                color: "#fff"
                            }
                        }

                        var printaTitulo = (titulo) => {

                            var splitted = titulo.split(" ")

                            var texto = ""
                            var linkHref = false
                            var todo = false
                            var notaId = false
                            var icon = false
                            var tag = false

                            splitted.forEach(e => {
                                if (e.toUpperCase().includes("LINK:")) {
                                    var spl = e.replace("link:", "").replace("LINK:", "")
                                    if (spl.toLowerCase().includes("http")) {
                                        linkHref = spl
                                    } else if (spl.toLowerCase().includes("file://")) {
                                        linkHref = spl
                                    } else {
                                        notaId = spl
                                    }

                                } else if (e.toUpperCase().includes("TODOS:")) {
                                    todo = e.replace("TODOS:", "").replace("todos:", "")
                                } else if (e.toUpperCase().includes("NOTA:")) {
                                    notaId = e.replace("NOTA:", "").replace("nota:", "")
                                } else if (e.toUpperCase().includes("ICON:")) {
                                    icon = e.replace("ICON:", "").replace("icon:", "").toUpperCase()
                                } else if (e.toUpperCase().includes("TAG:")) {
                                    tag = e.replace("TAG:", "").replace("tag:", "").toUpperCase();
                                } else {
                                    texto += e + " "
                                }
                            })

                            texto = texto.trim()

                            var retornoLink = linkHref !== false &&
                                <Stack direction="row" spacing={1}>
                                    <Typography sx={estiloTitulo}>
                                        {texto}
                                    </Typography>
                                    <Link href={linkHref} target={"_blank"}>[LINK]</Link>
                                </Stack>

                            var retornoTodo = todo !== false && <Typography sx={estiloTitulo}>
                                <Link onClick={() => {
                                    dispatch(setSelectedListaById(todo))
                                }}>[{texto}]</Link>
                            </Typography>

                            var retornoNota = notaId !== false && <Typography sx={estiloTitulo}>
                                <LinkRouter to={"/notetaker/editor/" + notaId} >NOTA: {texto}</LinkRouter>
                            </Typography>

                            var retornoIcon = ""
                            var retornoTag = ""

                            if (tag !== false) {
                                retornoTag = <Typography sx={{ ...estiloTag, backgroundColor: generateColor(tag) }}>
                                    {tag}
                                </Typography>

                            }

                            if (icon !== false) {
                                switch (icon) {
                                    case "STAR":
                                        retornoIcon = <StarIcon sx={{ color: "#c20000" }} />
                                        break
                                    case "COUNTER":
                                        retornoIcon = <AddCircle sx={{ color: "#41a61c" }} />
                                        break
                                }
                            }

                            var retorno = <Stack direction="row" spacing={1}>

                                <Box sx={{
                                    display: retornoTag !== "" ? "block" : "flex"
                                }} >
                                    {retornoIcon}
                                    {retornoTag}
                                </Box>
                                {retornoLink ? retornoLink :
                                    retornoTodo ? retornoTodo :
                                        retornoNota ? retornoNota : <Typography
                                            sx={estiloTitulo}
                                        > {texto}
                                        </Typography>
                                }

                            </Stack>

                            return retorno

                        }


                        return <Card
                            draggable
                            onDragStart={() => dragStart(index)}
                            onDragEnd={() => dragEnd(index)}
                            onDragEnter={() => dragEnter(index)}
                            onDragOver={(e) => e.preventDefault()}
                            className='todo-row'
                            key={e.id}
                            sx={estiloRow} >
                            <Stack direction={"row"} spacing={1}
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center"
                                }}>
                                <Checkbox
                                    checked={e.dataConclusao != null}
                                    onClick={() => toggleConclusaoTodo(e)} />

                                {e.dataConclusao != null && <Typography>
                                    {formatDateSemHoras(e.dataConclusao)} -
                                </Typography>}

                                {(todoEditForm == null || todoEditForm.id != e.id) && printaTitulo(e.titulo)}

                                {todoEditForm != null && todoEditForm.id == e.id &&
                                    <Input
                                        type="text"
                                        value={todoEditForm.titulo}
                                        sx={{ width: "100%" }}
                                        onChange={updateTodoEditTitulo} />}

                                {todoEditForm != null && todoEditForm.id == e.id &&
                                    <Button color="danger" onClick={salvarEdicaoTodo}>Salvar</Button>}

                                {(todoEditForm == null || todoEditForm.id != e.id) && <DeleteIcon
                                    className="todo-delete-button"
                                    sx={{ display: "none" }}
                                    onClick={() =>
                                        dispatch(startConfirmacao(novaConfirmacao("Deseja remover o todo: " + e.titulo + "?", () => removerTodo(e.id))))
                                    } />}

                                {(todoEditForm == null || todoEditForm.id != e.id) &&
                                    <EditIcon
                                        className='todo-edit-button'
                                        sx={{ display: "none" }}
                                        onClick={() => toggleEditTodo(e.id, e.titulo)} />}


                            </Stack>
                        </Card>
                    })}
                    <br />

                </Stack>
            </Box>
        </Stack>
    </Box>
}

function Carregando() {
    return <Grid container>
        <Grid xs={12} sx={{
            diplay: "flex",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center"
        }}>
            Experando banco de dados...
        </Grid>
    </Grid>
}

function TODOs() {

    var dispatch = useDispatch()
    var loaded = false

    var dbs = useSelector((state) => state.dbs.dbs)

    if (Object.keys(dbs).includes("todos")) {
        loaded = dbs.todos.loaded
    }

    React.useEffect(() => {
        dispatch(triggerLoadNovoDB(
            novoDB("todos", 10, "listas", (p) => {

                var listas = p.payload
                var versao = p.versao

                dispatch(carregaLista(listas != null ? listas : []))
            })
        ))
    }, []);

    return !loaded ? <Carregando /> :
        <Grid container sx={{ padding: "5px 10px" }}>
            <ModalNovaLista />
            <Grid xs={12}>
                <Stack direction={"column"} spacing={1}>
                    <ListasManager />
                    <DetalhesLista />
                </Stack>
            </Grid>
        </Grid>
}

export default TODOs